module.exports = __webpack_public_path__ + "img/immigration-black@2x.e89d0f9c.png";